<div class="modal-signup modal-content border-all-10px-modal">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px border-bottom padding-right-7px padding-left-8px padding-top-7px">

        <div class="row">
          <div class="col-md-12">
            <label class="margin-bottom-0px color-Assign font-weight-bold" *ngIf="PatientName">{{PatientName}}</label>
          </div>
        </div>
        
          <div class="row font-size-12px">
            <div class="col-md-2  padding-right-10px">
              <label class="font-weight-normal font-size-12px margin-bottom-0px">Bill No </label>
            </div>:
            <div class="col-md-5 padding-right-0px padding-left-10px" *ngIf="Billno">
              <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{Billno}}</label>
            </div>
          </div>
          
          <div class="row font-size-12px">
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-4   padding-right-5px">
                  <label class="font-weight-normal font-size-12px margin-bottom-0px">Receipt Dt </label>
                </div>:
                <div class="col-md-5 padding-right-0px padding-left-10px" *ngIf="ReceiptDate">
                  <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{ReceiptDate | date:'MMM-dd-yyyy'}}</label>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-4  text-align-right padding-right-5px">
                  <label class="font-weight-normal font-size-12px margin-bottom-0px">Receipt No </label>
                </div>:
                <div class="col-md-7 padding-right-0px padding-left-10px" *ngIf="Receiptno">
                  <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{Receiptno}}</label>
                </div>
              </div>
            </div>
          </div>

      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px">
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
          <div class="modal-body padding-top-0px">








            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">

               

                <div class="row margin-top-3px">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                    <div class="row margin-bottom-3px">
                      <div class="col-md-5 text-align-right padding-left-0px">
                        <label for="firstName" class="margin-bottom-0px margin-top-3px">Current Payment Model</label>
                      </div>:
                      <div class="col-md-5">
                        <h4 class="margin-bottom-0px margin-top-3px color-Assign font-weight-bold font-size-16px" *ngIf="PaymentInstructions">{{PaymentInstructions}}</h4>
                        <!--<CodeTypeValue CodeType="IVFAC" id="CurrentSaveTestMedCycleActivitiesRequest.ActivityType"
                       [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" SelectedValue=""
                       name="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" required>
        </CodeTypeValue>-->
                        <!--<input type="text" class="form-control" placeholder="Test"
               id="CurrentSaveIvfCycleMedicineDataRequest.Form"
               [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
               name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
               maxlength="100" required>
        <small class="form-text text-danger"
               *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
        <small class="form-text text-danger"
               *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                        <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                                 id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                                 [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                                 name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
        </CustomDataByRequestType>-->
                      </div>

                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right padding-left-0px">
                        <label for="firstName" class="margin-bottom-0px margin-top-5px">Change To</label>
                      </div>
                      <div class="col-md-5">

                        <CodeTypeValue CodeType="PYTMD" id="CurrentSavePaymentModeInfoRequest.ChangeToPayMode"
                                       [(ngModel)]="CurrentSavePaymentModeInfoRequest.ChangeToPayMode" SelectedValue=""
                                       name="CurrentSavePaymentModeInfoRequest.ChangeToPayMode" >
                        </CodeTypeValue>
                        <!--<input type="text" class="form-control" placeholder="Test"
               id="CurrentSaveIvfCycleMedicineDataRequest.Form"
               [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
               name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
               maxlength="100" required>
        <small class="form-text text-danger"
               *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
        <small class="form-text text-danger"
               *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                        <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                                 id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                                 [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                                 name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
        </CustomDataByRequestType>-->
                      </div>

                    </div>

                  </div>
                </div>
              

              


              </div>
            </div>


         

















          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
